import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-admit-claim',
  templateUrl: './admit-claim.component.html',
  styleUrls: ['./admit-claim.component.css'],
})
export class AdmitClaimComponent implements OnInit {
  @Output() resultIntimationEvent = new EventEmitter<boolean>();
  @Output() resultTypeEvent = new EventEmitter<string>();

  enableButton: boolean = true;

  constructor() {}

  ngOnInit() {}

  enableButtons() {
    this.enableButton = false;
  }
}
